import AddTipBlock, { AddTipBlockProps } from './AddTipBlock';

import withPresenter from './AddTipBlock.presenter';
import withInteractor from './AddTipBlock.interactor';
import withErrorHandler from '../../../modules/error/ErrorHandlerWrapper';

export type { AddTipBlockProps };

export default withInteractor(withPresenter(withErrorHandler(AddTipBlock)));
